import api from './api';

interface CreateOnlinePopupStoreRequest {
  name: string;
  slug: string;
  categories: string[];
  thumbnailImages: string[];
  startDate: string; // 형식: "YYYY-MM-DD"
  endDate: string; // 형식: "YYYY-MM-DD"
  playTime: number;
  eventTitle: string;
  eventDescription: string;
  introTitle: string;
  introContent: string;
  preOpenButtonText?: string;
  inProgressButtonText?: string;
  closedButtonText?: string;
  products: CreateProductRequest[];
}

interface CreateProductRequest {
  name: string;
  imageUrl: string;
  isDiscounted?: boolean;
  discountInfo?: string;
  originPrice: number;
  discountPrice?: number;
}

interface UpdateProductRequest {
  name?: string;
  imageUrl?: string;
  isDiscounted?: boolean;
  discountInfo?: string;
  originPrice?: number;
  discountPrice?: number;
}

interface UpdateOnlinePopupStoreRequest {
  name?: string;
  slug?: string;
  categories?: string[];
  thumbnailImages?: string[];
  startDate?: string;
  endDate?: string;
  playTime?: number;
  eventTitle?: string;
  eventDescription?: string;
  introTitle?: string;
  introContent?: string;
  preOpenButtonText?: string;
  inProgressButtonText?: string;
  closedButtonText?: string;
  products?: UpdateProductRequest[];
}

export const CreateOnlinePopupStore = async (data: CreateOnlinePopupStoreRequest) => {
  try {
    const response = await api.post('/api/admin/v2/online-popup-stores', data);
    return response.data;
  } catch (error) {
    console.error('온라인 팝업스토어 생성 실패:', error);
    throw error;
  }
};

export const FetchOnlinePopupStores = async () => {
  try {
    const { data } = await api.get('/api/admin/v2/online-popup-stores');
    return data.data;
  } catch (error) {
    console.error('온라인 팝업스토어 목록 조회 실패:', error);
    return [];
  }
};

export const FetchOnlinePopupStoreDetail = async (id: number) => {
  try {
    const { data } = await api.get(`/api/admin/v2/online-popup-stores/${id}`);
    return data.data;
  } catch (error) {
    console.error('온라인 팝업스토어 상세 조회 실패:', error);
    return null;
  }
};

export const UpdateOnlinePopupStore = async (id: number, data: UpdateOnlinePopupStoreRequest) => {
  try {
    const response = await api.patch(`/api/admin/v2/online-popup-stores/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('온라인 팝업스토어 수정 실패:', error);
    throw error;
  }
};

// 설탕 거래 내역 조회
export const FetchOnlinePopupStoreSugarTransactions = async (id: number) => {
  try {
    const { data } = await api.get(`/api/admin/v2/online-popup-stores/${id}/sugar-transactions`);
    return data;
  } catch (error) {
    console.error('설탕 거래 내역 조회 실패:', error);
    throw error;
  }
};

// 친구 초대 내역 조회
export const FetchOnlinePopupStoreFriendInvitations = async (id: number) => {
  try {
    const { data } = await api.get(`/api/admin/v2/online-popup-stores/${id}/friend-invitations`);
    return data;
  } catch (error) {
    console.error('친구 초대 내역 조회 실패:', error);
    throw error;
  }
}; 